export default __webpack_public_path__ + "img/share-screen.e08a3ba3.svg";